import { t } from "@/i18n-js/instance";
import type { Student } from "@/react/components/Spaces/CourseSpace/AdminSummary/Engagement/types";
import { useCourseCustomLabels } from "@/react/components/Spaces/CourseSpace/Shared/useCourseCustomLabels";
import { ChatIcon } from "@circle-react/components/Chat/ChatIcon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { UserImage } from "@circle-react-shared/uikit/UserImage";

interface HeaderProps {
  student: Student;
}

export const Header = ({ student }: HeaderProps) => {
  const { translatedLabels } = useCourseCustomLabels();
  return (
    <div className="border-primary rounded-md border p-4">
      <div className="flex w-full justify-between">
        <div className="flex gap-x-3">
          <UserImage src={student.avatar_url} name={student.name} size="10" />
          <div>
            <Typography.LabelMd size="medium" weight="semibold" as="p">
              {student.name}
            </Typography.LabelMd>
            <Typography.LabelSm size="regular" color="text-light" as="p">
              {student.headline}
            </Typography.LabelSm>
          </div>
        </div>
        <ChatIcon
          communityMemberId={student.community_member_id}
          variant="button"
        />
      </div>
      <div className="mt-4">
        <p>
          <Typography.LabelSm size="medium" weight="semibold">
            {t(
              "courses.admin_summary.student_progress_modal.header.lessons_completed.title",
              {
                lessonPlural: translatedLabels.lesson.plural,
              },
            )}
          </Typography.LabelSm>{" "}
          <Typography.LabelSm size="regular" color="text-light">
            {t(
              "courses.admin_summary.student_progress_modal.header.lessons_completed.description",
              {
                completed: student.completed_lessons_count,
                total: student.lessons_count,
              },
            )}
          </Typography.LabelSm>
        </p>
        <p>
          <Typography.LabelSm size="medium" weight="semibold">
            {t(
              "courses.admin_summary.student_progress_modal.header.course_completed.title",
            )}
          </Typography.LabelSm>{" "}
          <Typography.LabelSm size="regular" color="text-light">
            {t(
              "courses.admin_summary.student_progress_modal.header.course_completed.description",
              { total: student.progress },
            )}
          </Typography.LabelSm>
        </p>
      </div>
    </div>
  );
};
